import { render, staticRenderFns } from "./HomePartnerCompanyComponent.vue?vue&type=template&id=fec728da&scoped=true&"
import script from "./HomePartnerCompanyComponent.vue?vue&type=script&lang=js&"
export * from "./HomePartnerCompanyComponent.vue?vue&type=script&lang=js&"
import style0 from "./HomePartnerCompanyComponent.vue?vue&type=style&index=0&id=fec728da&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fec728da",
  null
  
)

export default component.exports